// Page scroll lock for overlays (the nav drawer, the product fullscreen
// viewer, the search modal, the mobile filter sheet).
//
// `document.body.style.overflow = "hidden"` on its own is not enough on iOS
// Safari, which keeps scrolling the page behind the overlay; setting
// overflow on the root element as well is what it honours. The lock is
// reference counted so two overlays open at once (the search modal over the
// drawer, say) release it only when the last one closes, and a component
// that unmounts mid-lock cannot leave the page stuck.
//
// The scrollbar gutter is compensated on the body so desktop content does
// not shift sideways when the bar disappears. Each overlay's scrim should
// also carry `touch-action: none` in CSS so a swipe on it is not handed to
// the page.

let depth = 0;

export function lockScroll() {
  if (typeof document === "undefined") return;
  if (depth++ > 0) return;
  const root = document.documentElement;
  const body = document.body;
  const scrollbar = window.innerWidth - root.clientWidth;
  root.style.overflow = "hidden";
  body.style.overflow = "hidden";
  body.style.overscrollBehavior = "none";
  if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`;
}

export function unlockScroll() {
  if (typeof document === "undefined" || depth === 0) return;
  if (--depth > 0) return;
  const root = document.documentElement;
  const body = document.body;
  root.style.overflow = "";
  body.style.overflow = "";
  body.style.overscrollBehavior = "";
  body.style.paddingRight = "";
}

/** True while at least one overlay holds the lock. */
export function isScrollLocked() {
  return depth > 0;
}
